import { useEffect, useState } from 'react'

import { type TrackUploadStatusEnum } from '@/shared/api'
import { PrimaryButton } from '@/shared/ui'
import { Button, Divider, Flex, Radio, Select, Space } from 'antd'
import { type RadioChangeEvent } from 'antd/lib'
import { useUnit } from 'effector-react'

import { TrackUploadStatus } from '../../lib'
import {
  $tracksTableFilters,
  tracksTableFiltersChanged,
} from '../../model/tracks-table.model'

export const TracksTableFiltersMenu = () => {
  const filters = useUnit($tracksTableFilters)
  const isArchiveFilter = filters.IsArchive
  const uploadStatusesFilter = filters.UploadStatuses
  const changeFilters = useUnit(tracksTableFiltersChanged)

  const [selectedIsArchiveFilter, setSelectedIsArchiveFilter] = useState<
    boolean | undefined
  >(isArchiveFilter)
  const [selectedUploadStatusesFilter, setSelectedUploadStatusesFilter] =
    useState<TrackUploadStatusEnum[] | undefined>(uploadStatusesFilter)

  useEffect(() => {
    const currentIsArchiveFilter = filters.IsArchive
    if (currentIsArchiveFilter !== selectedIsArchiveFilter) {
      setSelectedIsArchiveFilter(currentIsArchiveFilter)
    }
    const currentUploadStatusesFilter = filters.UploadStatuses
    if (currentUploadStatusesFilter !== selectedUploadStatusesFilter) {
      setSelectedUploadStatusesFilter(currentUploadStatusesFilter)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <div style={{ width: 300 }}>
      <Divider style={{ marginTop: 0, marginBottom: 8 }} />
      <Flex vertical gap={8}>
        Архивация
        <Radio.Group
          onChange={(e: RadioChangeEvent) =>
            setSelectedIsArchiveFilter(e.target.value)
          }
          value={selectedIsArchiveFilter}
        >
          <Radio.Button value={undefined}>Выбрать все</Radio.Button>
          <Radio.Button value={false}>Текущие</Radio.Button>
          <Radio.Button value={true}>Архивные</Radio.Button>
        </Radio.Group>
        Статус загрузки
        <Select
          mode="multiple"
          showSearch={false}
          optionFilterProp="label"
          value={selectedUploadStatusesFilter}
          onChange={setSelectedUploadStatusesFilter}
        >
          <Select.Option
            key={TrackUploadStatus.Uploaded}
            value={TrackUploadStatus.Uploaded}
            label="Загруженные"
          >
            Загруженные
          </Select.Option>
          <Select.Option
            key={TrackUploadStatus.Uploading}
            value={TrackUploadStatus.Uploading}
            label="Не загруженные"
          >
            Не загруженные
          </Select.Option>
          <Select.Option
            key={TrackUploadStatus.DeletionPending}
            value={TrackUploadStatus.DeletionPending}
            label="Помеченные на удаление"
          >
            Помеченные на удаление
          </Select.Option>
        </Select>
      </Flex>
      <Space style={{ marginTop: 16 }}>
        <Button
          onClick={() => {
            setSelectedIsArchiveFilter(undefined)
            setSelectedUploadStatusesFilter([TrackUploadStatus.Uploaded])
            changeFilters({
              IsArchive: undefined,
              UploadStatuses: [TrackUploadStatus.Uploaded],
            })
          }}
        >
          Сбросить
        </Button>
        <PrimaryButton
          onClick={() => {
            if (
              selectedIsArchiveFilter === isArchiveFilter &&
              selectedUploadStatusesFilter === uploadStatusesFilter
            )
              return
            changeFilters({
              IsArchive: selectedIsArchiveFilter,
              UploadStatuses: selectedUploadStatusesFilter,
            })
          }}
        >
          Применить
        </PrimaryButton>
      </Space>
    </div>
  )
}
